// extracted by mini-css-extract-plugin
export default {"productDescription":"D--z","featuredDescription":"E--z","description":"F--z","more":"G--z","descriptionSku":"H--z"};